import i18n from 'i18next';
import FormSelectBox from '../../../../components/Inputs/FormSelectBox';
import { useGetPalletLoadType } from '../../hooks';

export const PalletLoadTypeSelect = ({
  placeholder = i18n.t('translation:default.fields.palletLoadType.placeholder'),
  label = i18n.t('translation:default.fields.palletLoadType.label'),
  rules = [],
  name,
  editMode,
  margin,
  tabIndex,
}) => {
  const { data: options = [], isLoading } = useGetPalletLoadType({ enabled: editMode });

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      tabIndex={tabIndex}
    />
  );
};
